import { type Layer, type NormalLayerSpec, defineNormalLayer } from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';
import { type CustomEvent } from './multiTable';

type Event = {
  type: string;
  data: CustomEvent;
};

const visInfo: Layer['visInfo'] = {
  id: 'text',
  name_en: 'text',
  // name_zh: '要点文本',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    text: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    },
    title: {
      itemType: [DEFINE.STR],
      category: DEFINE.SINGLE
    }
  }
};

export interface Spec extends NormalLayerSpec {
  /** 使用的数据集索引，默认为 0 */
  dataIndex?: number;
  encoding: {
    text: string;
    title: string;
  };
  maxHeight?: number;
  width?: number;
  customEvent?: (data: Event) => void;
}

export const layer = defineNormalLayer<Spec>({
  type: visInfo.id,
  cdn: 'https://s.thsi.cn/cd/iwc-datav-standard-chart/aigc/0.15.1/text.umd.min.js',
  visInfo,
  render(api, spec, $dom) {
    const { data: dataArray, token } = api;
    const {
      dataIndex = 0,
      encoding: { text, title },
      maxHeight = 520,
      width = 570,
      customEvent
    } = spec;
    const textTheme = token?.dvText;
    const data = dataArray[dataIndex].values;

    const transformData: {
      text: string;
      title: string;
    }[] = [];

    data.forEach(item => {
      transformData.push({
        text: item[text] as string,
        title: item[title] as string
      });
    });

    const textInstance = new VisallText.Text($dom, {
      config: transformData,
      maxHeight,
      width,
      themeConfig: textTheme,
      customEvent
    });

    // 处理事件监听
    if (textInstance.on) {
      textInstance.on('change:selected', (...args: unknown[]) => {
        const event = args[0] as { type: string; data: CustomEvent };
        if (customEvent) {
          customEvent(event);
        }
      });
    }

    return () => {
      // 清理DOM
      $dom.innerHTML = '';

      // 调用渲染器实例的destroy方法（必须存在）
      textInstance.destroy();
    };
  }
});
